module.exports = __webpack_public_path__ + "static/media/vector-4964.2498e38a.svg";